// ============================================================================
// Primitivos de link (regra FC7 — .claude/rules/fc7-design-system.md).
//
// Hyperlink de texto é SEMPRE azul #185FA5 com underline no hover — o CTA
// escuro (#1f1f18) é exclusivo de BOTÕES. Para link externo, usar `as="a"`
// + href/target/rel; para link-com-handler, `as="button"` + type="button".
// ============================================================================
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

const linkBase = css`
   color: ${({ theme }) => theme.colors.link};
   font-weight: 600;
   text-decoration: none;
   cursor: pointer;

   &:hover {
      color: ${({ theme }) => theme.colors.linkHover};
      text-decoration: underline;
   }
   &:focus-visible {
      outline: none;
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.focusRing};
      border-radius: 4px;
   }
`;

// Link de texto corrido / "Voltar para listagem" (as="button" p/ handlers)
export const TextLink = styled(Link)`
   ${linkBase}
   display: inline-flex;
   align-items: center;
   gap: 6px;

   /* modo botão-sem-moldura (ex.: BackLink com onClick) */
   background: transparent;
   border: 0;
   padding: 0;
   font-family: inherit;
   font-size: inherit;
`;

// Célula-link de tabela (ex.: order_number no RoutingItemList)
export const CellLink = styled(Link)`
   ${linkBase}
   font-size: inherit;
`;

// Link com moldura de botão ghost (caso MapsButton — abrir mapa em nova aba)
export const LinkButton = styled.a`
   display: inline-flex;
   align-items: center;
   justify-content: center;
   gap: 8px;
   height: 44px;
   padding: 0 16px;
   border-radius: 11px;
   border: 1px solid ${({ theme }) => theme.colors.border};
   background: ${({ theme }) => theme.colors.surface};
   color: ${({ theme }) => theme.colors.textPrimary};
   font-size: 14px;
   font-weight: 600;
   text-decoration: none;
   cursor: pointer;
   transition: background 0.13s ease;

   &:hover {
      background: rgba(24, 95, 165, 0.06);
      color: ${({ theme }) => theme.colors.textPrimary};
      text-decoration: none;
   }
   &:focus-visible {
      outline: none;
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.focusRing};
   }
`;

// Pílula de navegação cruzada (caso "Ver parcelamento" do BillingCharge)
export const PillLink = styled(Link)`
   display: inline-flex;
   align-items: center;
   gap: 8px;
   width: fit-content;
   padding: 6px 14px;
   border-radius: 999px;
   border: 1px solid rgba(24, 95, 165, 0.3);
   background: rgba(24, 95, 165, 0.08);
   color: ${({ theme }) => theme.colors.link};
   font-size: 13px;
   font-weight: 600;
   text-decoration: none;
   cursor: pointer;

   &:hover {
      background: rgba(24, 95, 165, 0.14);
      text-decoration: none;
   }
`;

// Affordance visual padrão de linha clicável de tabela. O COMPORTAMENTO de
// clique (onClick vs onDoubleClick) é decisão de cada tela — aqui é só visual.
export const clickableRowCss = css`
   cursor: pointer;
   transition: background 0.12s ease;

   &:hover td {
      background: rgba(24, 95, 165, 0.06);
   }
`;

export const ClickableRow = styled.tr`
   ${clickableRowCss}
`;
